import { useMutation } from '@apollo/client';
import { GET_PATIENTS } from '../gqlSchemes/getPatients';
import { useSnackbar } from 'notistack';
import { DEACTIVATE_PATIENT } from '../gqlSchemes/deactivatePatient';
import { useTranslation } from 'react-i18next';
import { getMessageFromError } from "lib/enums/errorCodes"

export default function useDeactivatePatient() {
  const [deactivate] = useMutation(DEACTIVATE_PATIENT);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const deactivatePatient = (id) => {
    deactivate({
      variables: {
        record: {
          id,
          handleCareTeamBlockingObjectsStrategy: 'CANCEL',
        },
      },
      onCompleted: async (res) => {
        if (res.user.patientUser.deletePatient.ok) {
          enqueueSnackbar(t('Patient was successfully deactivated'), {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
          });
        } else {
          enqueueSnackbar(getMessageFromError(res.user.patientUser.deletePatient.error, t), {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
          });
        }
      },
      refetchQueries: [GET_PATIENTS],
    });
  };

  return { deactivatePatient };
}
